<div>
  <h1 class="margin-bottom-20" dsContent [contentPath]="'enrollment.nextActionText'"></h1>
  <p class="margin-bottom-20" dsContent [contentPath]="'enrollment.nextActionBodyText1'"></p>
  <p class="margin-bottom-20" dsContent [contentPath]="'enrollment.nextActionBodyText2'"></p>
  <p class="margin-bottom-20" dsContent [contentPath]="'enrollment.nextActionBodyText3'"></p>
</div>
